import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import OverettIcon from "../../../assets/mountains.svg?react";
import { RightPanelTabs } from "../../../constants/Panels";
import { AppContext, OverettContext } from "../../../Context";
import { setRightPanelActiveTab } from "../../../store/appSlice";
import { setIsEditingOverett, setOverettCreationStep } from "../../../store/overettSlice";
import { setSearchResultsOpen } from "../../../store/searchSlice";
import { getOverettFeatures } from "../../../utils/overettUtils";
import { OverettCreationStep } from "./OverettEditorContent";
import { StoreState } from "../../../store/rootReducer";

const OverettButton = () => {
    const dispatch = useDispatch();
    const appContext = useContext(AppContext);
    const overettContext = useContext(OverettContext);
    const selectedFeature = appContext?.selectedFeature.value;

    const hasUnsavedChanges = useSelector((state: StoreState) => state.app.hasUnsavedChanges);

    const setOverettFeatures = async () => {
        if (!selectedFeature) return;

        const overettFeatures = await getOverettFeatures(selectedFeature);
        if (!overettFeatures) return;

        overettContext!.overettLinjeRef.value.current = overettFeatures[0];
        overettContext?.overettObjects.set({ upper: overettFeatures[1], lower: overettFeatures[2] });

        for (const feature of overettFeatures) {
            if (feature?.layer) {
                feature.layer.visible = true;
            }
        }
    };

    return (
        <button
            className="feature-viewer-tool"
            onClick={() => {
                if (hasUnsavedChanges) {
                    const confirmProceed = globalThis.confirm(
                        "Du har ulagrede endinger i det aktive verktøyet. Vil du fortsette, dette vil forkaste endringene?"
                    );
                    if (!confirmProceed) {
                        return;
                    }
                }
                dispatch(setIsEditingOverett(true));
                dispatch(setOverettCreationStep(OverettCreationStep.EditOverett));
                dispatch(setSearchResultsOpen(false));
                dispatch(setRightPanelActiveTab(RightPanelTabs.OVERETT));
                setOverettFeatures();
            }}
        >
            <OverettIcon />
            <span>Overett</span>
        </button>
    );
};

export default OverettButton;
